import { render } from "./InActivation.vue?vue&type=template&id=42e444f2"
import script from "./InActivation.vue?vue&type=script&lang=js"
export * from "./InActivation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__